import React, { useEffect } from "react";
import { createPortal } from "react-dom";
import { IconAlert } from "./icons";

// Small final-verification popup shown over the review modal. Yes -> onConfirm
// (triggers the real backend submit). Disabled while loading.
const ConfirmDialog = ({
  open, title, message,
  confirmLabel = "Yes, Submit", cancelLabel = "Review Again",
  onConfirm, onCancel, loading,
}) => {
  useEffect(() => {
    if (!open) return;
    const onKey = (e) => { if (e.key === "Escape" && !loading) onCancel(); };
    document.addEventListener("keydown", onKey);
    return () => document.removeEventListener("keydown", onKey);
  }, [open, loading, onCancel]);

  if (!open) return null;

  return createPortal(
    <div
      className="crs-confirm-overlay"
      onMouseDown={(e) => { if (e.target === e.currentTarget && !loading) onCancel(); }}
    >
      <div className="crs-confirm" role="alertdialog" aria-modal="true" aria-label={title}>
        <span className="crs-confirm__icon"><IconAlert /></span>
        <h3 className="crs-confirm__title">{title}</h3>
        <p className="crs-confirm__msg">{message}</p>
        <div className="crs-confirm__actions">
          <button type="button" className="btn-ed btn-ed--ghost" onClick={onCancel} disabled={loading}>
            {cancelLabel}
          </button>
          <button type="button" className="btn-ed btn-ed--primary" onClick={onConfirm} disabled={loading}>
            {loading && <span className="crs-spinner" aria-hidden="true" />}
            {loading ? "Submitting…" : confirmLabel}
          </button>
        </div>
      </div>
    </div>,
    document.body
  );
};

export default ConfirmDialog;
